module.exports = __webpack_public_path__ + "img/photo-0013.3a35497a.jpg";